import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx } from "vue"

import { useVModel } from '@vueuse/core'
import CosInputView from '../CosView/input.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  value: {
    type: [String, Number]
  },
  ignorePlaceHolder: {
    type: Boolean, // 是否忽略占位输入
    default: false
  },
  trim: {
    type: Boolean, // 去掉前后空格
    default: true
  },
  placeholder: {
    type: String
  },
  view: {
    type: Boolean
  },
  allowClear: {
    type: Boolean,
    default: true
  }
},
  emits: ['update:value'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const modelValue = useVModel(props, 'value', emit)
const changeTrim = () => {
  if (typeof modelValue.value === 'string' && props.trim) {
    modelValue.value = modelValue.value?.trim()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (__props.view)
    ? (_openBlock(), _createBlock(CosInputView, _mergeProps({ key: 0 }, _ctx.$attrs, { value: __props.value }), null, 16, ["value"]))
    : (_openBlock(), _createBlock(_component_a_input, _mergeProps({ key: 1 }, _ctx.$attrs, {
        value: _unref(modelValue),
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(modelValue) ? (modelValue).value = $event : null)),
        style: {"width":"100%"},
        placeholder: __props.ignorePlaceHolder?'':(__props.placeholder || _ctx.$t('common.pleaseInput')),
        allowClear: __props.allowClear,
        onBlur: changeTrim
      }), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "prefix"),
          _renderSlot(_ctx.$slots, "suffix")
        ]),
        _: 3
      }, 16, ["value", "placeholder", "allowClear"]))
}
}

})